/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-16 09:43:49
 * @LastEditTime: 2019-09-23 15:01:14
 * @LastEditors: Please set LastEditors
 */
/**
 * 解析url参数
 * @example ?id=12345&a=b
 * @return Object {id:12345,a:b}
 */
import { Toast, Dialog } from 'vant';

// 地址字符串参数解析为键值对
export function urlParse () {
    const url = window.location.search;
    const obj = {};
    const reg = /[?&][^?&]+=[^?&]+/g;
    const arr = url.match(reg);
    // ['?id=12345', '&a=b']
    if (arr) {
        arr.forEach((item) => {
            const tempArr = item.substring(1).split('=');
            const key = decodeURIComponent(tempArr[0]);
            const val = decodeURIComponent(tempArr[1]);
            obj[key] = val;
        });
    }
    return obj;
}
// 判断机型
export function isAndroidOrIOS() {
    const u = navigator.userAgent;
    const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; // android终端
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
    if (isAndroid) {
        return 'android';
    }
    if (isiOS) {
        return 'ios';
    }
    return false;
}
// 号码校验
export function validatePhone(phone) {
    if (!/^0[0-9]{2,3}-[0-9]{7,8}$/.test(phone) && !/(^1[3456789][0-9]{9}$)|(^(400)-(\d{3})-(\d{4})$)/.test(phone)) {
        return false;
    } else {
        return true;
    }
}
// 防抖
export function debounce (func, delay) {
    let timer;
    return function (...args) {
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(() => {
            func.apply(this, args);
        }, delay);
    };
}

// toast加载框
export function toastLoading(message = '') {
    return Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: 'circular',
        message: message
    });
}

// 清除toast加载框
export function clearToastLoading(toast) {
    toast.clear();
}
// 判断字符串中是否含Emoji表情
export function hasEmoji(name) {
    var reg = new RegExp(/\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g);
    var hasEmoji = reg.test(name);
    return hasEmoji;
}

// 确认弹出框
export function confirmModal(title, then, cancel) {
    Dialog.confirm({
        title: title,
        message: ''
    })
        .then(() => {
            then && then();
        })
        .catch(() => {
            cancel && cancel();
        });
}
